import { Component, EventEmitter , Input , Output,OnInit } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';


@Component({
  selector: 'app-table-insights-percentage',
  templateUrl: './table-insights-percentage.component.html',
  styleUrls: ['./table-insights-percentage.component.scss']
})
export class TableInsightsPercentageComponent implements ViewCell,OnInit {


    @Input() value: string | number;
    @Input() rowData: any;

	  @Output() redirectToAnotherPage: EventEmitter<any> = new EventEmitter();

    constructor() { }

    colData : any;
    eventNumber : number | any;
    percentCompareValue : number;  
    percentCompareClass : string;
    showSimpleColumn : boolean;    // this flag is whether to show simple value count or on false show modifed styled div
	  showSimpleColumnVal: String | any;
	
    // data point variables 
    isDataPointClick: boolean;     // flag to decide whether this column is insights data point clickable to redirect detailed logs
    dataRedirectTo : string;
    dataPointSummryBy: string;     // if isDataPointClick true then summary column  
    dataPointSummryValue: string;  // if isDataPointClick true then summary column actual row value

    ngOnInit() {

      this.colData = this.value;   // get column specific data
      
      this.eventNumber = this.colData.count;
      this.percentCompareValue = +this.colData.cmp < 0 ? (0 - (+this.colData.cmp)) : +this.colData.cmp; 
      this.percentCompareClass = this.getColor( +this.colData.cmp );

      this.isDataPointClick = false    // default false
		  this.dataPointSummryBy = '';
      this.dataPointSummryValue = '';

      this.showSimpleColumn = false;   // default false
		  this.showSimpleColumnVal = ''; 
		
      
      if( this.colData['isDataPoint'] || this.colData['showSimpleColumn'] ){

        if( this.colData['isDataPoint'] ){
          this.isDataPointClick = true;
          this.dataPointSummryBy = this.colData['summarize_by'];
          this.dataPointSummryValue = this.rowData['key'];
          this.dataRedirectTo = this.colData['redirectTo'];
        }
        if( this.colData['showSimpleColumn'] ){
          this.showSimpleColumn = true;
          this.showSimpleColumnVal = ( ( this.colData['colValue'] ) ? this.colData['colValue'] : this.rowData[ this.colData['colName'] ] );
        }

        if( this.eventNumber !== undefined ){
          this.isDataPointClick = parseFloat( this.eventNumber ) > 0 ? true : false;
        }

        if( this.showSimpleColumnVal ){
          this.isDataPointClick = parseFloat( this.showSimpleColumnVal ) > 0 ? true : false;
        }

      }

    }

    getColor( count ){
      console.log(count);
      if( + count > 0 ){    // high
        return "number-color-box-success";
      }else if(+count < 0){  //low   
        return "number-color-box-primary";        
      }else{           //  no change
        return "number-color-box-secondary";
      }
    }

    onClick() {

      let emitData = {
        redirectTo : this.dataRedirectTo,
        SummarizeBy : this.dataPointSummryBy,
        summarizeValue : this.dataPointSummryValue,
			  columnValue : ( this.eventNumber !== undefined ) ? this.eventNumber : this.showSimpleColumnVal
      }
      this.redirectToAnotherPage.emit( emitData );		
    }

}
